import React, {Component} from 'react';
import { CheckBox } from '../../../../common/custom-form/checkbox.component';
import { InputField } from '../../../../common/custom-form/input-filter-component';
import { SelectField } from '../../../../common/custom-form/select-filter.component';
export default class AccountAuditRules extends Component {
    constructor(props) {
        super(props);
        this.state={
            inputValue:"",
            filterSelected: "", 
        }
    }

    getDataOnTable() {    
       
        this.props.getData(false);
      }
    render(){
        return(
            <div className='manage-detail-container'>               
                <div className="manage-invoice-detail">  
                    {this.props.CheckBoxValue.map((value,id)=>
                        <CheckBox key={id} label={value} />
                    )}
                </div>
                        
            </div>
        );
    }
}